var _path;
import * as React from "react";
function SvgAngleLightDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.018 20.802L5.615 7.192a1.388 1.388 0 010-1.964l.82-.82a1.388 1.388 0 011.965 0L20 16.226 31.6 4.419a1.388 1.388 0 011.964 0l.82.82a1.388 1.388 0 010 1.964l-13.402 13.61a1.398 1.398 0 01-1.964-.01zm1.964 14.79L34.385 21.98a1.388 1.388 0 000-1.964l-.82-.82a1.388 1.388 0 00-1.965 0L20 31.015 8.4 19.208a1.388 1.388 0 00-1.964 0l-.82.82a1.388 1.388 0 000 1.964l13.402 13.61a1.398 1.398 0 001.964-.01z"
  })));
}
export default SvgAngleLightDown;